import React, { useEffect, useState } from "react";
import { HiDotsVertical } from "react-icons/hi";
import { useLocation, useNavigate, useParams } from "react-router";
import {
  ADD_NEW_INSPECTION,
  ISO_WELD_LOG,
  NCR_REPORT,
  PROJECT_REPORT,
  WELDING_GAS_INSPECTION_FORM,
  WELDING_MACHINE_CALIBRATION,
  WELDING_WPQ_INSPECTION,
} from "../../utils/RouteConstant";
import { Box, Button, Menu, MenuItem, Modal } from "@mui/material";
import Eye from "../../../asesst/Eye.svg";
import Trash from "../../../asesst/Trash.svg";
import { TfiDownload } from "react-icons/tfi";
import { useDispatch, useSelector } from "react-redux";
import {
  DownloadIsoMaterialCSV,
  DownloadIsoWeldLogCSV,
  DownloadWeldingGasCSV,
  DownloadWeldingMachineCSV,
  DownloadWeldingWPQCSV,
  GetInspectionList,
  GetNcrReportList,
  GetProjectReportList,
  GetWeldLogList,
  GetWeldingGasList,
  GetWeldingMachineCalibartionList,
  GetWeldingWPQList,
  deleteIsoMaterialDetails,
  deleteNcrReportDetails,
  deleteProjectReportDetails,
  deleteWeldLogDetails,
  deleteWeldMachineDetails,
  deleteWeldWPQDetails,
  deleteWeldingGasDetails,
  downloadIsoWeldLogPdf,
  downloadIsomaterialPdf,
  downloadNcrReportPdf,
  downloadProjectReportPdf,
} from "../../../redux/action/InspectionDetails/InspectionDetailsAction";
import Pagination from "../../customComponent/Pagination";
import DownloadImages from "./DownloadImages";
import { ImageBaseUrl } from "../../utils/helperData";
import FilterSidebar from "./filterData";
import FilterListIcon from "@mui/icons-material/FilterList";
import { filterActions } from "../../../redux/action/InspectionFilter/InspectionFilterAction";
import { GrDocumentCsv } from "react-icons/gr";
import ErrorBoundary from "../../common/ErrorBoundry";
import { FaDownload } from "react-icons/fa";
import JSZip from "jszip";

const InspectionDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { projectId } = useParams();
  const dispatch = useDispatch();
  const [selectedIndex, setSelectedIndex] = useState(
    location.state?.selectedInspectionIndex || 0
  );
  const [selectedRows, setSelectedRows] = useState(new Set());
  const [menuState, setMenuState] = useState({
    anchorEl: null,
    selectedRow: null,
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const rowsPerPageOptions = [10, 20, 50, 100, "All"];
  const [searchTerm, setSearchTerm] = useState("");
  const [sortField, setSortField] = useState();
  const [sortOrder, setSortOrder] = useState();
  const [downloadModalOpen, setDownloadModalOpen] = useState(false);
  const [deleteConfirmation, setDeleteConfirmation] = useState({
    open: false,
    itemToDelete: null,
  });
  const [isDownloading, setIsDownloading] = useState(false);
  const [filters, setFilters] = useState({
    status: [],
    dateRange: { start: "", end: "" },
    inspectors_name: [],
    loc_id: [],
    system: [],
    surface_name: [],
    description_id: [],
    size_id: [],
    receiving: [],
    heat: [],
    tag_id: [],
    lot_number: [],
    serial_number: [],
    accept_criteria: [],
    ref_number: [],
    line: [],
    cert_id: [],
    welder_id: [],
    naming: [],
    p_id: [],
    line_no: [],
    iso_draw_no: [],
    equipment_id: [],
    mechanical_contractor: [],
    classification: [],
    material_type: [],
  });

  const { isLoading, error, inspectionDetaildata, totalCount } = useSelector(
    (state) => state.inspectionDetails
  );

  const totalPages =
    rowsPerPage === "All" ? 1 : Math.ceil(totalCount / rowsPerPage);
  const handleRowsPerPageChange = (event) => {
    const value = event.target.value;

    if (value === "All") {
      setRowsPerPage(totalCount);
      setCurrentPage(1);
    } else {
      setRowsPerPage(Number(value));
      setCurrentPage(1);
    }
  };

  useEffect(() => {
    setRowsPerPage(10);
    setCurrentPage(1);
    setSortField();
    setSortOrder();
    setFilters({
      status: [],
      dateRange: { start: "", end: "" },
      inspectors_name: [],
      loc_id: [],
      system: [],
      surface_name: [],
      description_id: [],
      size_id: [],
      receiving: [],
      heat: [],
      tag_id: [],
      lot_number: [],
      serial_number: [],
      accept_criteria: [],
      ref_number: [],
      line: [],
      cert_id: [],
      welder_id: [],
      naming: [],
      p_id: [],
      line_no: [],
      iso_draw_no: [],
      equipment_id: [],
      mechanical_contractor: [],
      classification: [],
      material_type: [],
    });
  }, [selectedIndex]);
  const handleDownload = async (rowData) => {
    setIsDownloading(true);
    try {
      const { document, ref_no, iso_draw_no } = rowData;
      const sanitizedFileName = ref_no.replace(/[\/\\:*?"<>|]/g, "_");

      const downloadFile = async (fileName, customName) => {
        try {
          const url = `${ImageBaseUrl}${fileName}`;
          const response = await fetch(url);
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          const blob = await response.blob();
          const link = window.document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          // link.download = customName;
          link.download = customName.endsWith(".pdf")
            ? customName
            : `${customName}.pdf`;
          window.document.body.appendChild(link);
          link.click();
          window.document.body.removeChild(link);
        } catch (error) {
          console.error(`Error downloading ${fileName}:`, error);
        }
      };
      switch (selectedIndex) {
        case 0: // Isometric Material Form
          if (rowData?._id) {
            await dispatch(
              downloadIsomaterialPdf(rowData?._id, ref_no, { isZip: false })
            );
          }
          break;

        case 1: // Welding Gas Inspection Form
          if (document && document.length > 0) {
            for (const fileName of document) {
              await downloadFile(fileName, sanitizedFileName);
            }
          }
          break;

        case 2: // Weld Machine Calibration
          if (document && document.length > 0) {
            for (const fileName of document) {
              await downloadFile(fileName, sanitizedFileName);
            }
          }
          break;

        case 3: // Welding WPQ Inspection Form
          if (document && document.length > 0) {
            for (const fileName of document) {
              await downloadFile(fileName, sanitizedFileName);
            }
          }
          break;

        case 4: // ISO Weld Log Form
          if (rowData?._id) {
            await dispatch(
              downloadIsoWeldLogPdf(rowData?._id, iso_draw_no, { isZip: false })
            );
          }
          break;

        case 5: // Project Report
          if (rowData?._id) {
            await dispatch(
              downloadProjectReportPdf(rowData?._id, ref_no, { isZip: false })
            );
          }
          break;

        case 6: // Ncr Report
          if (rowData?._id) {
            await dispatch(
              downloadNcrReportPdf(rowData?._id, ref_no, { isZip: false })
            );
          }
          break;

        default:
          console.warn("Download not implemented for this section");
          break;
      }
    } catch (error) {
      console.error("Error downloading files:", error);
    } finally {
      setIsDownloading(false);
      setDownloadModalOpen(false);
    }
  };

  const handleDownloadZip = async (rowDataList) => {
    setIsDownloading(true);
    const zip = new JSZip();
 const folderName = buttons[selectedIndex].label;
    try {
      for (const rowData of rowDataList) {
        const { document, ref_no, iso_draw_no } = rowData;
        const sanitizedFileName = ref_no.replace(/[\/\\:*?"<>|]/g, "_");

        const downloadFile = async (fileName, customName) => {
          try {
            const response = await fetch(
              `${process.env.REACT_APP_IMAGE_BASE_URL}${fileName}`
            );
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            const blob = await response.blob();
            zip.file(`${customName}${getFileExtension(fileName)}`, blob);
          } catch (error) {
            console.error(`Error downloading ${fileName}:`, error);
          }
        };

        const getFileExtension = (fileName) => {
          return fileName.substring(fileName.lastIndexOf(".")) || ".pdf";
        };

        const ensureBlob = (data) => {
          if (data instanceof Blob) return data;
          if (data instanceof ArrayBuffer) return new Blob([data]);
          if (typeof data === "string") {
            return new Blob([data], { type: "application/pdf" });
          }
          throw new Error("Unsupported data type");
        };

        switch (selectedIndex) {
          case 0: // Isometric Material Form
            if (rowData?._id) {
              const pdfData = await dispatch(
                downloadIsomaterialPdf(rowData?._id, ref_no, { isZip: true })
              );
              const pdfBlob = ensureBlob(pdfData);
              zip.file(`${sanitizedFileName}.pdf`, pdfBlob);
            }
            break;

          case 1: // Welding Gas Inspection Form
            if (document && document.length > 0) {
              for (const fileName of document) {
                await downloadFile(fileName, sanitizedFileName);
              }
            }
            break;
          case 2: // Weld Machine Calibration
            if (document && document.length > 0) {
              for (const fileName of document) {
                await downloadFile(fileName, sanitizedFileName);
              }
            }
            break;
          case 3: // Welding WPQ Inspection Form
            if (document && document.length > 0) {
              for (const fileName of document) {
                await downloadFile(fileName, sanitizedFileName);
              }
            }
            break;

          case 4: // ISO Weld Log Form
            if (rowData?._id) {
              const pdfData = await dispatch(
                downloadIsoWeldLogPdf(rowData?._id, iso_draw_no, {
                  isZip: true,
                })
              );
              const pdfBlob = ensureBlob(pdfData);
              zip.file(`${iso_draw_no}.pdf`, pdfBlob);
            }
            break;

          case 5: // Project Report
            if (rowData?._id) {
              const pdfData = await dispatch(
                downloadProjectReportPdf(rowData?._id, ref_no, { isZip: true })
              );
              const pdfBlob = ensureBlob(pdfData);
              zip.file(`${sanitizedFileName}.pdf`, pdfBlob);
            }
            break;

          case 6: // Ncr Report
            if (rowData?._id) {
              const pdfData = await dispatch(
                downloadNcrReportPdf(rowData?._id, ref_no, { isZip: true })
              );
              const pdfBlob = ensureBlob(pdfData);
              zip.file(`${sanitizedFileName}.pdf`, pdfBlob);
            }
            break;

          default:
            console.warn("Download not implemented for this section");
            break;
        }
      }

      // Generate the zip file
      const zipBlob = await zip.generateAsync({ type: "blob" });
      const zipUrl = window.URL.createObjectURL(zipBlob);
      const link = document.createElement("a");
      link.href = zipUrl;
      // link.download = "documents.zip";
      link.download = `${folderName}.zip`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(zipUrl);
    } catch (error) {
      console.error("Error in zip download process:", error);
    } finally {
      setIsDownloading(false);
    }
  };

  const [isFilterSidebarOpen, setIsFilterSidebarOpen] = useState(false);

  useEffect(() => {
    if (selectedIndex === 0) {
      dispatch(
        GetInspectionList(
          currentPage,
          searchTerm,
          rowsPerPage,
          sortField,
          sortOrder,
          projectId
        )
      );
    } else if (selectedIndex === 1) {
      dispatch(
        GetWeldingGasList(
          currentPage,
          searchTerm,
          rowsPerPage,
          sortField,
          sortOrder,
          projectId
        )
      );
    } else if (selectedIndex === 2) {
      dispatch(
        GetWeldingMachineCalibartionList(
          currentPage,
          searchTerm,
          rowsPerPage,
          sortField,
          sortOrder,
          projectId
        )
      );
    } else if (selectedIndex === 3) {
      dispatch(
        GetWeldingWPQList(
          currentPage,
          searchTerm,
          rowsPerPage,
          sortField,
          sortOrder,
          projectId
        )
      );
    } else if (selectedIndex === 4) {
      dispatch(
        GetWeldLogList(
          currentPage,
          searchTerm,
          rowsPerPage,
          sortField,
          sortOrder,
          projectId
        )
      );
    } else if (selectedIndex === 5) {
      dispatch(
        GetProjectReportList(
          currentPage,
          searchTerm,
          rowsPerPage,
          sortField,
          sortOrder,
          projectId
        )
      );
    } else if (selectedIndex === 6) {
      dispatch(
        GetNcrReportList(
          currentPage,
          searchTerm,
          rowsPerPage,
          sortField,
          sortOrder,
          projectId
        )
      );
    } 
  }, [
    dispatch,
    currentPage,
    searchTerm,
    rowsPerPage,
    projectId,
    sortField,
    sortOrder,
    selectedIndex,
  ]);

  useEffect(() => {
    const actions = [
      GetInspectionList,
      GetWeldingGasList,
      GetWeldingMachineCalibartionList,
      GetWeldingWPQList,
      GetWeldLogList,
      GetProjectReportList,
      GetNcrReportList,
    ];

    if (selectedIndex >= 0 && selectedIndex < actions.length) {
      dispatch(
        actions[selectedIndex](
          currentPage,
          searchTerm,
          rowsPerPage,
          sortField,
          sortOrder,
          projectId
        )
      );
    }
  }, [
    dispatch,
    currentPage,
    searchTerm,
    rowsPerPage,
    projectId,
    sortField,
    sortOrder,
    selectedIndex,
  ]);

  const handleMenuClick = (event, row) => {
    setMenuState({
      anchorEl: event.currentTarget,
      selectedRow: row,
    });
  };

  const handleClose = () => {
    setMenuState({
      anchorEl: null,
      selectedRow: null,
    });
  };

  useEffect(() => {
    if (location.state?.selectedInspectionIndex !== undefined) {
      setSelectedIndex(location.state.selectedInspectionIndex);
    }
  }, [location.state]);
  const createArrowStyles = () => {
    const baseStyle = {
      backgroundColor: "#F3F4F6",
      color: "#374151",
      padding: "16px 28px",
      fontWeight: "600",
      position: "relative",
      transition: "background-color 0.3s ease",
      cursor: "pointer",
    };

    const clipPaths = {
      left: "polygon(0 0, 85% 0, 100% 50%, 85% 100%, 0 100%, 0% 100%)",
      right: "polygon(0 0, 85% 0, 100% 50%, 85% 100%, 0 100%, 15% 50%)",
      finalRight: "polygon(0 0, 100% 0, 100% 100%, 0 100%, 15% 50%)",
    };
    const getClipPaths = () => {
      const width = window.innerWidth;

      if (width <= 576) {
        return {
          left: "polygon(0 0, 60% 0, 100% 50%, 60% 100%, 0 100%, 0 100%)",
          right: "polygon(0 0, 60% 0, 100% 50%, 60% 100%, 0 100%, 40% 50%)",
          finalRight: "polygon(0 0, 100% 0, 100% 100%, 0 100%, 40% 50%)",
        };
      } else if (width <= 768) {
        return {
          left: "polygon(0 0, 70% 0, 100% 50%, 70% 100%, 0 100%, 0 100%)",
          right: "polygon(0 0, 70% 0, 100% 50%, 70% 100%, 0 100%, 30% 50%)",
          finalRight: "polygon(0 0, 100% 0, 100% 100%, 0 100%, 30% 50%)",
        };
      } else if (width <= 992) {
        return {
          left: "polygon(0 0, 75% 0, 100% 50%, 75% 100%, 0 100%, 0 100%)",
          right: "polygon(0 0, 75% 0, 100% 50%, 75% 100%, 0 100%, 25% 50%)",
          finalRight: "polygon(0 0, 100% 0, 100% 100%, 0 100%, 25% 50%)",
        };
      } else if (width <= 1200) {
        return {
          left: "polygon(0 0, 80% 0, 100% 50%, 80% 100%, 0 100%, 0 100%)",
          right: "polygon(0 0, 80% 0, 100% 50%, 80% 100%, 0 100%, 20% 50%)",
          finalRight: "polygon(0 0, 100% 0, 100% 100%, 0 100%, 20% 50%)",
        };
      }

      return clipPaths;
    };

    const responsiveClipPaths = getClipPaths();

    return {
      base: baseStyle,
      left: { ...baseStyle, clipPath: responsiveClipPaths.left },
      right: { ...baseStyle, clipPath: responsiveClipPaths.right },
      finalRight: { ...baseStyle, clipPath: responsiveClipPaths.finalRight },
    };
  };

  const arrowStyles = createArrowStyles();

  const buttons = [
    {
      label: "Material Inspection",
      style: arrowStyles.left,
      route: ADD_NEW_INSPECTION,
      fetchAction: () =>
        dispatch(
          GetInspectionList(
            currentPage,
            searchTerm,
            rowsPerPage,
            sortField,
            sortOrder,
            projectId
          )
        ),
    },
    {
      label: "Welding Gas Certification",
      style: arrowStyles.right,
      route: WELDING_GAS_INSPECTION_FORM,
      fetchAction: () =>
        dispatch(
          GetWeldingGasList(
            currentPage,
            searchTerm,
            rowsPerPage,
            sortField,
            sortOrder,
            projectId
          )
        ),
    },
    {
      label: "Machine Certification",
      style: arrowStyles.right,
      route: WELDING_MACHINE_CALIBRATION,
      fetchAction: () =>
        dispatch(
          GetWeldingMachineCalibartionList(
            currentPage,
            searchTerm,
            rowsPerPage,
            sortField,
            sortOrder,
            projectId
          )
        ),
    },
    {
      label: "Welding Operators / Welder Certification",
      style: arrowStyles.right,
      route: WELDING_WPQ_INSPECTION,
      fetchAction: () =>
        dispatch(
          GetWeldingWPQList(
            currentPage,
            searchTerm,
            rowsPerPage,
            sortField,
            sortOrder,
            projectId
          )
        ),
    },
    {
      label: "Isometric Weld Logs",
      style: arrowStyles.right,
      route: ISO_WELD_LOG,
      fetchAction: () =>
        dispatch(
          GetWeldLogList(
            currentPage,
            searchTerm,
            rowsPerPage,
            sortField,
            sortOrder,
            projectId
          )
        ),
    },
    {
      label: "NCR Reports",
      style: arrowStyles.right,
      route: PROJECT_REPORT,
      fetchAction: () =>
        dispatch(
          GetProjectReportList(
            currentPage,
            searchTerm,
            rowsPerPage,
            sortField,
            sortOrder,
            projectId
          )
        ),
    },
    {
      label: "Project Reports",
      style: arrowStyles.finalRight,
      route: NCR_REPORT,
      fetchAction: () =>
        dispatch(
          GetNcrReportList(
            currentPage,
            searchTerm,
            rowsPerPage,
            sortField,
            sortOrder,
            projectId
          )
        ),
    },
  ];

  useEffect(() => {
    buttons[selectedIndex].fetchAction();
  }, [selectedIndex, currentPage, searchTerm, rowsPerPage]);

  const handleApplyFilters = (filters) => {
    const hasFilters = Object.keys(filters).some((key) => {
      if (Array.isArray(filters[key])) {
        return filters[key].length > 0;
      }
      return (
        filters[key] !== undefined &&
        filters[key] !== null &&
        filters[key] !== ""
      );
    });

    if (hasFilters) {
      const action = filterActions[selectedIndex];
      if (action) {
        dispatch(action({ projectId, filters }));
      }
    } else {
      const actions = [
        GetInspectionList,
        GetWeldingGasList,
        GetWeldingMachineCalibartionList,
        GetWeldingWPQList,
        GetWeldLogList,
        GetProjectReportList,
        GetNcrReportList,
      ];

      if (selectedIndex >= 0 && selectedIndex < actions.length) {
        dispatch(
          actions[selectedIndex](
            currentPage,
            searchTerm,
            rowsPerPage,
            sortField,
            sortOrder,
            projectId
          )
        );
      }
    }
  };

  const handleButtonClick = (index) => {
    setSelectedIndex(index);
    setCurrentPage(1);
    setIsFilterSidebarOpen(false);
  };

  const handleViewDetails = () => {
    if (menuState.selectedRow) {
      const selectedRoute = buttons[selectedIndex].route;
      navigate(selectedRoute, {
        state: {
          data: menuState?.selectedRow,
          formType: buttons[selectedIndex]?.label,
        },
      });
      handleClose();
    }
  };

  const handleDelete = () => {
    setDeleteConfirmation({
      open: true,
      itemToDelete: menuState.selectedRow,
      type: selectedIndex,
    });
    handleClose();
  };

  const handleDeleteConfirm = async () => {
    if (deleteConfirmation.itemToDelete) {
      try {
        switch (deleteConfirmation.type) {
          case 0:
            await dispatch(
              deleteIsoMaterialDetails(deleteConfirmation.itemToDelete._id)
            );
            break;
          case 1:
            await dispatch(
              deleteWeldingGasDetails(deleteConfirmation.itemToDelete._id)
            );
            break;
          case 2:
            await dispatch(
              deleteWeldMachineDetails(deleteConfirmation.itemToDelete._id)
            );
            break;
          case 3:
            await dispatch(
              deleteWeldWPQDetails(deleteConfirmation.itemToDelete._id)
            );
            break;
          case 4:
            await dispatch(
              deleteWeldLogDetails(deleteConfirmation.itemToDelete._id)
            );
            break;
          case 5:
            await dispatch(
              deleteProjectReportDetails(deleteConfirmation.itemToDelete._id)
            );
            break;
          case 6:
            await dispatch(
              deleteNcrReportDetails(deleteConfirmation.itemToDelete._id)
            );
            break;
          default:
            console.warn("Unknown tab index for deletion");
            break;
        }
        buttons[selectedIndex].fetchAction();
      } catch (error) {
        console.error("Error deleting item:", error);
      }
    }
    setDeleteConfirmation({
      open: false,
      itemToDelete: null,
      type: null,
    });
  };

  const handleDeleteCancel = () => {
    setDeleteConfirmation({
      open: false,
      itemToDelete: null,
    });
  };
  const handleSort = (field) => {
    if (field === sortField) {
      setSortOrder(sortOrder === "ASC" ? "DESC" : "ASC");
    } else {
      setSortField(field);
      setSortOrder("ASC");
    }
  };

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const allIds = (
        inspectionDetaildata?.data || inspectionDetaildata?.result
      )?.data?.map((row) => row?._id);
      setSelectedRows(new Set(allIds));
    } else {
      setSelectedRows(new Set());
    }
  };
  const handleDownloadSelected = async () => {
    setIsDownloading(true);
    try {
      const inspectionData =
        inspectionDetaildata?.data?.data || inspectionDetaildata?.result?.data;

      let rowDataList = [];
      if (Array.isArray(inspectionData)) {
        for (const rowId of selectedRows) {
          const rowData = inspectionData?.find((row) => row?._id === rowId);
          rowDataList.push(rowData);
        }
        await handleDownloadZip(rowDataList);
      } else {
        console.error(
          "inspectionDetaildata.data.data is not an array:",
          inspectionDetaildata.data.data
        );
      }
    } catch (error) {
      console.error("Error downloading files:", error);
    } finally {
      setIsDownloading(false);
      setDownloadModalOpen(false);
      setSelectedRows(new Set()); 
    }
  };

  const renderTableHeader = () => {
    const headers = {
      0: [
        { label: "Inspection ID", field: "ref_no" },
        { label: "Receiving #", field: "receiving" },
        { label: "Line #", field: "line" },
        { label: "Material Type", field: "material_type" },
        { label: "Classification", field: "classification" },
        { label: "Material Description", field: "description_id" },
        { label: "Surface Finish", field: "surface_name" },
        { label: "Size", field: "size_id" },
        { label: "Heat1 #", field: "heat" },
        { label: "Tag ID", field: "tag_id" },
        { label: "Inspector Name", field: "inspectors_name" },
        { label: "Creation Date", field: "createdAt" },
        { label: "Status", field: "form_status" },
        { label: "", field: null },
      ],
      1: [
        { label: "Inspection ID", field: "" },
        { label: "Lot/Serial Number", field: "number" },
        { label: "Location", field: "locName" },
        { label: "Inspection Date", field: "ins_date" },
        { label: "Acceptance Criteria", field: "accept_criteria" },
        { label: "Inspector Name", field: "inspectors_name" },
        { label: "Creation Date", field: "createdAt" },
        { label: "Status", field: "form_status" },
        { label: "", field: null },
      ],
      2: [
        { label: "Inspection ID", field: "ref_no" },
        { label: "Weld Serial Number", field: "number" },
        { label: "Location", field: "locName" },
        { label: "Inspection Date", field: "ins_date" },
        { label: "Acceptance Criteria", field: "accept_criteria" },
        { label: "Inspector Name", field: "inspectors_name" },
        { label: "Creation Date", field: "createdAt" },
        { label: "Status", field: "form_status" },
        { label: "", field: null },
      ],
      3: [
        { label: "Inspection ID", field: "" },
        { label: "Welder ID", field: "number" },
        { label: "Name", field: "name" },
        { label: "Cert ID/Type", field: "cert_id" },
        { label: "Acceptance Criteria", field: "accept_criteria" },
        { label: "Inspector Name", field: "inspectors_name" },
        { label: "Creation Date", field: "createdAt" },
        { label: "Status", field: "form_status" },
        { label: "", field: null },
      ],
      4: [
        { label: "ISO Drawing No.", field: "iso_draw_no" },
        { label: "Inspection ID", field: "ref_no" },
        { label: "System Categoory", field: "system" },
        { label: "Line Class", field: "line_class" },
        { label: "P & ID", field: "p_id" },
        { label: "Inspector Name", field: "inspectors_name" },
        { label: "Creation Date", field: "createdAt" },
        { label: "Status", field: "form_status" },
        { label: "", field: null },
      ],
      5: [
        { label: "Inspection ID", field: "" },
        { label: "Location", field: "locName" },
        { label: "Inspection Date", field: "ins_date" },
        { label: "Contractor", field: "mechanical_contractor" },
        { label: "System", field: "system" },
        { label: "Material/Equipment ID", field: "equipment_id" },
        { label: "Inspector Name", field: "inspectors_name" },
        { label: "Creation Date", field: "createdAt" },
        { label: "Status", field: "form_status" },
        { label: "", field: null },
      ],
      6: [
        { label: "Inspection ID", field: "" },
        { label: "Location", field: "locName" },
        { label: "Inspection Date", field: "ins_date" },
        { label: "Contractor", field: "mechanical_contractor" },
        { label: "System", field: "system" },
        { label: "Material/Equipment ID", field: "equipment_id" },
        { label: "Inspector Name", field: "inspectors_name" },
        { label: "Creation Date", field: "createdAt" },
        { label: "Status", field: "form_status" },
        { label: "", field: null },
      ],
    };

    // return headers[selectedIndex]?.map((header, index) => (
    //   <th
    //     key={index}
    //     className="py-2 px-3 font-medium text-gray-600 text-sm md:text-base lg:px-4 lg:py-3"
    //     onClick={() => header.field && handleSort(header.field)}
    //     style={{
    //       cursor: header.field ? "pointer" : "default",
    //       minWidth: "100%",
    //     }}
    //   >
    //     <div className="flex items-center">
    //       <span
    //         className={header.label.length > 12 ? "block" : "whitespace-nowrap"}
    //       >
    //         {header.label}
    //       </span>
    //       {header.field && (
    //         <span className="ml-1">
    //           {sortField === header.field && (sortOrder === "ASC" ? "↑" : "↓")}
    //         </span>
    //       )}
    //     </div>
    //   </th>
    // ));

    return (
      <>
        <th>
          <input
            type="checkbox"
            onChange={handleSelectAll}
            checked={
              selectedRows.size ===
              (inspectionDetaildata?.data?.data?.length ||
                inspectionDetaildata?.result?.data?.length ||
                0)
            }
          />
        </th>
        {headers[selectedIndex]?.map((header, index) => {
          const isSortable = Boolean(header.field);
          const sortIndicator =
            sortField === header.field
              ? sortOrder === "ASC"
                ? "↑"
                : "↓"
              : null;

          return (
            <th
              key={index}
              className="py-2 px-3 font-medium text-gray-600 text-sm md:text-base lg:py-3"
              onClick={() => isSortable && handleSort(header.field)}
              style={{
                cursor: isSortable ? "pointer" : "default",
                minWidth: "100%",
              }}
            >
              <div className="flex items-center">
                <span
                  className={
                    header.label.length > 12 ? "block" : "whitespace-nowrap"
                  }
                >
                  {header.label}
                </span>
                {sortIndicator && <span className="ml-1">{sortIndicator}</span>}
              </div>
            </th>
          );
        })}
      </>
    );
  };

  const FORM_STATUS_STYLES = {
    0: { label: "Open", bgColor: "bg-blue-500", textColor: "text-white" },
    1: { label: "Complete", bgColor: "bg-green-500", textColor: "text-white" },
    2: { label: "Delete", bgColor: "bg-red-500", textColor: "text-white" },
    3: { label: "Issue", bgColor: "bg-orange-500", textColor: "text-white" },
    4: {
      label: "Top Ready",
      bgColor: "bg-yellow-500",
      textColor: "text-white",
    },
    5: { label: "Ready", bgColor: "bg-purple-500", textColor: "text-white" },
  };
  const renderTableRow = (row) => {
    const isChecked = selectedRows.has(row._id);
    const rowRenderers = {
      0: () => (
        <>
          <td>
            <input
              type="checkbox"
              checked={isChecked}
              onChange={() => {
                const newSelectedRows = new Set(selectedRows);
                if (isChecked) {
                  newSelectedRows.delete(row._id);
                } else {
                  newSelectedRows.add(row._id);
                }
                setSelectedRows(newSelectedRows);
              }}
            />
          </td>
          <td className="py-3 px-4">
            <div className="relative group cursor-pointer">
              {row?.ref_no?.length > 5
                ? `${row?.ref_no.substring(0, 5)}...`
                : row?.ref_no}
              <span className="absolute hidden group-hover:block bg-black text-white text-sm rounded px-2 py-1 w-max z-10">
                {row?.ref_no}
              </span>
            </div>
          </td>

          <td className="py-3 px-4">{row?.receiving}</td>
          <td className="py-3 px-4">{row?.line}</td>
          <td className="py-3 px-4">{row?.material_type || "-"}</td>
          <td className="py-3 px-4">{row?.classification || "-"}</td>
          <td className="py-3 px-4">{row?.description_id}</td>
          <td className="py-3 px-4">{row?.surface_name}</td>
          <td className="py-3 px-4 relative group min-w-[100px]">
            {/* <div
              className={`max-w-[100px] truncate cursor-pointer ${
                row?.size_id?.length > 5
                  ? "hover:overflow-visible hover:whitespace-normal"
                  : ""
              }`}
              title={row?.size_id?.length > 10 ? row?.size_id : ""}
            >
              {row?.size_id?.length > 10
                ? `${row.size_id.slice(0, 10)}`
                : row?.size_id}
            </div> */}
            {row?.size_id}
          </td>
          <td className="py-3 px-4">{row?.heat}</td>
          <td className="py-3 px-4">{row?.tag_id}</td>
          <td className="py-3 px-4">{row?.inspectors_name}</td>
          <td className="px-4 py-3">
            {row?.createdAt
              ? new Date(row.createdAt).toLocaleDateString("en-US", {
                  month: "2-digit",
                  day: "2-digit",
                  year: "numeric",
                })
              : "-"}
          </td>
          <td className="px-4 py-3 whitespace-nowrap">
            <span
              className={`px-4 py-2 justify-center inline-flex font-lg text-base w-[100px] leading-5 rounded-lg ${
                FORM_STATUS_STYLES[row?.form_status]?.bgColor || "bg-gray-200"
              } ${
                FORM_STATUS_STYLES[row?.form_status]?.textColor ||
                "text-gray-700"
              }`}
            >
              {FORM_STATUS_STYLES[row?.form_status]?.label || "-"}
            </span>
          </td>
        </>
      ),
      1: () => (
        <>
          <td>
            <input
              type="checkbox"
              checked={isChecked}
              onChange={() => {
                const newSelectedRows = new Set(selectedRows);
                if (isChecked) {
                  newSelectedRows.delete(row._id);
                } else {
                  newSelectedRows.add(row._id);
                }
                setSelectedRows(newSelectedRows);
              }}
            />
          </td>
          <td className="py-3 px-4">{row?.ref_no}</td>
          <td className="py-3 px-4">{row?.number}</td>
          <td className="py-3 px-4">{row?.locName?.name}</td>
          <td className="px-4 py-3">
            {row?.ins_date
              ? new Date(row?.ins_date).toLocaleDateString("en-US", {
                  month: "2-digit",
                  day: "2-digit",
                  year: "numeric",
                })
              : "-"}
          </td>
          <td className="py-3 px-4">{row?.accept_criteria}</td>
          <td className="py-3 px-4">{row?.inspectors_name}</td>
          <td className="px-4 py-3">
            {row?.createdAt
              ? new Date(row.createdAt).toLocaleDateString("en-US", {
                  month: "2-digit",
                  day: "2-digit",
                  year: "numeric",
                })
              : "-"}
          </td>
          <td className="px-2 py-3 whitespace-nowrap">
            <span
              className={`px-4 py-2 justify-center inline-flex font-lg text-base w-[100px] leading-5 rounded-lg ${
                FORM_STATUS_STYLES[row?.form_status]?.bgColor || "bg-gray-200"
              } ${
                FORM_STATUS_STYLES[row?.form_status]?.textColor ||
                "text-gray-700"
              }`}
            >
              {FORM_STATUS_STYLES[row?.form_status]?.label || "-"}
            </span>
          </td>
        </>
      ),
      2: () => (
        <>
          <td>
            <input
              type="checkbox"
              checked={isChecked}
              onChange={() => {
                const newSelectedRows = new Set(selectedRows);
                if (isChecked) {
                  newSelectedRows.delete(row._id);
                } else {
                  newSelectedRows.add(row._id);
                }
                setSelectedRows(newSelectedRows);
              }}
            />
          </td>
          <td className="py-3 px-4">{row?.ref_no}</td>
          <td className="py-3 px-4">{row?.number}</td>
          <td className="py-3 px-4">{row?.locName?.name}</td>
          <td className="px-4 py-3">
            {row?.ins_date
              ? new Date(row?.ins_date).toLocaleDateString("en-US", {
                  month: "2-digit",
                  day: "2-digit",
                  year: "numeric",
                })
              : "-"}
          </td>
          <td className="py-3 px-4">{row?.accept_criteria}</td>
          {/* <td className="py-3 px-4">{row?.ncr ? "True" : "False"}</td> */}
          <td className="py-3 px-4">{row?.inspectors_name}</td>
          <td className="px-4 py-3">
            {row?.createdAt
              ? new Date(row.createdAt).toLocaleDateString("en-US", {
                  month: "2-digit",
                  day: "2-digit",
                  year: "numeric",
                })
              : "-"}
          </td>
          <td className="px-4 py-3 whitespace-nowrap">
            <span
              className={`px-4 py-2 justify-center inline-flex font-lg text-base w-[100px] leading-5 rounded-lg ${
                FORM_STATUS_STYLES[row?.form_status]?.bgColor || "bg-gray-200"
              } ${
                FORM_STATUS_STYLES[row?.form_status]?.textColor ||
                "text-gray-700"
              }`}
            >
              {FORM_STATUS_STYLES[row?.form_status]?.label || "-"}
            </span>
          </td>
        </>
      ),
      3: () => (
        <>
          <td>
            <input
              type="checkbox"
              checked={isChecked}
              onChange={() => {
                const newSelectedRows = new Set(selectedRows);
                if (isChecked) {
                  newSelectedRows.delete(row._id);
                } else {
                  newSelectedRows.add(row._id);
                }
                setSelectedRows(newSelectedRows);
              }}
            />
          </td>
          <td className="py-3 px-4">{row?.ref_no}</td>
          <td className="py-3 px-4">{row?.number}</td>
          <td className="py-3 px-4">{row?.name}</td>
          {/* <td className="py-3 px-4">{row?.locName?.name}</td> */}
          <td className="py-3 px-4">{row?.cert_id}</td>
          <td className="py-3 px-4">{row?.accept_criteria}</td>
          <td className="py-3 px-4">{row?.inspectors_name}</td>
          <td className="px-4 py-3">
            {row?.createdAt
              ? new Date(row.createdAt).toLocaleDateString("en-US", {
                  month: "2-digit",
                  day: "2-digit",
                  year: "numeric",
                })
              : "-"}
          </td>
          <td className="px-4 py-3 whitespace-nowrap">
            <span
              className={`px-4 py-2 justify-center inline-flex font-lg text-base w-[100px] leading-5 rounded-lg ${
                FORM_STATUS_STYLES[row?.form_status]?.bgColor || "bg-gray-200"
              } ${
                FORM_STATUS_STYLES[row?.form_status]?.textColor ||
                "text-gray-700"
              }`}
            >
              {FORM_STATUS_STYLES[row?.form_status]?.label || "-"}
            </span>
          </td>
        </>
      ),
      4: () => (
        <>
          <td>
            <input
              type="checkbox"
              checked={isChecked}
              onChange={() => {
                const newSelectedRows = new Set(selectedRows);
                if (isChecked) {
                  newSelectedRows.delete(row._id);
                } else {
                  newSelectedRows.add(row._id);
                }
                setSelectedRows(newSelectedRows);
              }}
            />
          </td>
          <td className="py-3 px-4">{row?.iso_draw_no}</td>
          <td className="py-3 px-6">{row?.ref_no}</td>
          <td className="py-3 px-6">{row?.system}</td>
          <td className="py-3 px-4">{row?.line_class}</td>
          <td className="py-3 px-4">{row?.p_id}</td>
          <td className="py-3 px-4">{row?.inspectors_name}</td>
          <td className="px-4 py-3">
            {row?.createdAt
              ? new Date(row.createdAt).toLocaleDateString("en-US", {
                  month: "2-digit",
                  day: "2-digit",
                  year: "numeric",
                })
              : "-"}
          </td>
          <td className="px-4 py-3 whitespace-nowrap">
            <span
              className={`px-4 py-2 justify-center inline-flex font-lg text-base w-[100px] leading-5 rounded-lg ${
                FORM_STATUS_STYLES[row?.form_status]?.bgColor || "bg-gray-200"
              } ${
                FORM_STATUS_STYLES[row?.form_status]?.textColor ||
                "text-gray-700"
              }`}
            >
              {FORM_STATUS_STYLES[row?.form_status]?.label || "-"}
            </span>
          </td>
        </>
      ),
      5: () => (
        <>
          <td>
            <input
              type="checkbox"
              checked={isChecked}
              onChange={() => {
                const newSelectedRows = new Set(selectedRows);
                if (isChecked) {
                  newSelectedRows.delete(row._id);
                } else {
                  newSelectedRows.add(row._id);
                }
                setSelectedRows(newSelectedRows);
              }}
            />
          </td>
          <td className="py-3 px-4">{row?.ref_no}</td>
          <td className="py-3 px-4">{row?.locName?.name}</td>
          <td className="py-3 px-4">
            {row?.ins_date
              ? new Date(row?.ins_date).toLocaleDateString("en-US", {
                  month: "2-digit",
                  day: "2-digit",
                  year: "numeric",
                })
              : "-"}
          </td>
          <td className="py-3 px-4">{row?.mechanical_contractor}</td>
          <td className="py-3 px-4">{row?.system}</td>
          <td className="py-3 px-4">{row?.equipment_id}</td>
          <td className="py-3 px-4">{row?.inspectors_name}</td>
          <td className="px-4 py-3">
            {row?.createdAt
              ? new Date(row.createdAt).toLocaleDateString("en-US", {
                  month: "2-digit",
                  day: "2-digit",
                  year: "numeric",
                })
              : "-"}
          </td>
          <td className="px-4 py-3 whitespace-nowrap">
            <span
              className={`px-4 py-2 justify-center inline-flex font-lg text-base w-[100px] leading-5 rounded-lg ${
                FORM_STATUS_STYLES[row?.form_status]?.bgColor || "bg-gray-200"
              } ${
                FORM_STATUS_STYLES[row?.form_status]?.textColor ||
                "text-gray-700"
              }`}
            >
              {FORM_STATUS_STYLES[row?.form_status]?.label || "-"}
            </span>
          </td>
        </>
      ),
      6: () => (
        <>
          <td>
            <input
              type="checkbox"
              checked={isChecked}
              onChange={() => {
                const newSelectedRows = new Set(selectedRows);
                if (isChecked) {
                  newSelectedRows.delete(row._id);
                } else {
                  newSelectedRows.add(row._id);
                }
                setSelectedRows(newSelectedRows);
              }}
            />
          </td>
          <td className="py-3 px-4">{row?.ref_no}</td>
          <td className="py-3 px-4">{row?.locName?.name}</td>
          <td className="py-3 px-4">
            {row?.ins_date
              ? new Date(row?.ins_date).toLocaleDateString("en-US", {
                  month: "2-digit",
                  day: "2-digit",
                  year: "numeric",
                })
              : "-"}
          </td>
          <td className="py-3 px-4">{row?.mechanical_contractor}</td>
          <td className="py-3 px-4">{row?.system}</td>
          <td className="py-3 px-4">{row?.equipment_id}</td>
          <td className="py-3 px-4">{row?.inspectors_name}</td>
          <td className="px-4 py-3">
            {row?.createdAt
              ? new Date(row.createdAt).toLocaleDateString("en-US", {
                  month: "2-digit",
                  day: "2-digit",
                  year: "numeric",
                })
              : "-"}
          </td>
          <td className="px-4 py-3 whitespace-nowrap">
            <span
              className={`px-4 py-2 justify-center inline-flex font-lg text-base w-[100px] leading-5 rounded-lg ${
                FORM_STATUS_STYLES[row?.form_status]?.bgColor || "bg-gray-200"
              } ${
                FORM_STATUS_STYLES[row?.form_status]?.textColor ||
                "text-gray-700"
              }`}
            >
              {FORM_STATUS_STYLES[row?.form_status]?.label || "-"}
            </span>
          </td>
        </>
      ),
    };
    return rowRenderers[selectedIndex]?.();
  };


  const handleDownloadImages = async (rowData) => {
    const { images } = rowData;
    const zip = new JSZip();

    if (images.length > 1) {
      for (const image of images) {
        const imageUrl = `${ImageBaseUrl}${image}`;
        const response = await fetch(imageUrl);
        const blob = await response.blob();
        zip.file(image, blob);
      }

      const zipBlob = await zip.generateAsync({ type: "blob" });
      const zipUrl = window.URL.createObjectURL(zipBlob);
      const link = document.createElement("a");
      link.href = zipUrl;
      link.download = `${rowData?.iso_draw_no}.zip`; 
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(zipUrl);
    } else if (images.length === 1) {
      const imageUrl = `${ImageBaseUrl}${images[0]}`;
      const response = await fetch(imageUrl);
      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = images[0]; 
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const renderMenuItems = () => {
    const items = [
      <MenuItem key="view" onClick={handleViewDetails}>
        <span className="text-[#1C3664] text-base font-poppins flex items-center">
          <img src={Eye} alt="view details" className="mr-2" />
          View Details
        </span>
      </MenuItem>,
      <MenuItem
        key="downloads"
        onClick={() => {
          if (
            selectedIndex === 6 ||
            selectedIndex === 5 ||
            selectedIndex === 4 ||
            selectedIndex === 3 ||
            selectedIndex === 2 ||
            selectedIndex === 1 ||
            selectedIndex === 0
          ) {
            handleDownload(menuState.selectedRow);
          } else {
            setDownloadModalOpen(true);
          }
          handleClose();
        }}
      >
        <span className="text-[#1C3664] text-base font-poppins flex items-center">
          <TfiDownload className="mr-2" />
          {isDownloading ? "Downloading..." : "Download"}
        </span>
      </MenuItem>,
    ];

      if (menuState.selectedRow?.images?.length > 0 && selectedIndex === 4) {
        items.push(
          <MenuItem
            key="downloadImages"
            onClick={() => handleDownloadImages(menuState.selectedRow)}
          >
            <span className="text-[#1C3664] text-base font-poppins flex items-center">
              <FaDownload className="mr-2" />
              Download Images
            </span>
          </MenuItem>
        );
      }

    if (
      selectedIndex === 0 ||
      selectedIndex === 1 ||
      selectedIndex === 2 ||
      selectedIndex === 3 ||
      selectedIndex === 4 ||
      selectedIndex === 5 ||
      selectedIndex === 6
    ) {
      items.push(
        <MenuItem key="delete" onClick={handleDelete}>
          <span className="text-[#FF5C5C] text-base font-poppins flex items-center">
            <img src={Trash} alt="delete" className="mr-2" />
            Delete
          </span>
        </MenuItem>
      );
    }

    return items;
  };

  const { downloadCsv } = useSelector((state) => state.inspectionDetails);

  useEffect(() => {
    if (selectedIndex === 0) {
      dispatch(DownloadIsoMaterialCSV(projectId, filters));
    } else if (selectedIndex === 1) {
      dispatch(DownloadWeldingGasCSV(projectId, filters));
    } else if (selectedIndex === 2) {
      dispatch(DownloadWeldingMachineCSV(projectId, filters));
    } else if (selectedIndex === 3) {
      dispatch(DownloadWeldingWPQCSV(projectId, filters));
    } else if (selectedIndex === 4) {
      dispatch(DownloadIsoWeldLogCSV(projectId, filters));
    } else {
      console.log("this is done");
    }
  }, [selectedIndex, filters]);

  const handleExportCSV = () => {
    if (downloadCsv) {
      const csvContent = `data:text/csv;charset=utf-8,${downloadCsv}`;
      const encodedUri = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", `${projectId}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      alert("No data available to download.");
    }
  };

  return (
    <div className="mx-auto p-4">
      <div className="flex items-center mb-8">
        {buttons.map((button, index) => (
          <button
            key={index}
            style={{
              ...arrowStyles?.base,
              ...button?.style,
              backgroundColor: selectedIndex === index ? "#005bb5" : "#F1F5F9",
              color: selectedIndex === index ? "white" : button.style.color,
            }}
            onClick={() => handleButtonClick(index)}
          >
            {button.label}
          </button>
        ))}
      </div>
      {isLoading ? (
        <>
          <span className="animate-spin">⌛</span>
          Loading...
        </>
      ) : error ? (
        <div>Error: {error}</div>
      ) : (
        <div className="relative overflow-x-auto ">
          <div className="flex items-center justify-between mb-4">
            <div className="text-xl font-semibold">
              Total Inspection:{" "}
              {inspectionDetaildata?.totalCount ||
                0 ||
                inspectionDetaildata?.result?.totalCount}
            </div>
            {/* <button
              className="p-2 pl-4 bg-gray-100 rounded-md hover:bg-gray-200 flex items-center"
              onClick={() => setIsFilterSidebarOpen(true)}
            >
              <FilterListIcon className="mr-2" />
              Filters
            </button> */}
            {selectedRows.size > 0 && (
              <Button variant="contained" onClick={handleDownloadSelected}>
                Download Selected File
              </Button>
            )}

            <div className="flex items-center gap-6">
              {/* Right-aligned Filters Button */}
              <button
                className="p-2 pl-4 bg-gray-100 rounded-md hover:bg-gray-200 flex items-center"
                onClick={() => setIsFilterSidebarOpen(true)}
              >
                <FilterListIcon className="mr-2" />
                Filters
              </button>

              {selectedIndex === 0 ||
              selectedIndex === 1 ||
              selectedIndex === 2 ||
              selectedIndex === 3 ||
              selectedIndex === 4 ? (
                <button
                  onClick={handleExportCSV}
                  className="bg-green-600 hover:bg-green-700 text-white font-semibold py-2 px-4 rounded flex items-center space-x-2"
                >
                  <GrDocumentCsv className="text-white text-xl" />
                  <span>Export CSV</span>
                </button>
              ) : (
                <> </>
              )}
            </div>
          </div>
          <table className="w-full bg-white border border-gray-200">
            <thead className="bg-gray-100  top-0 sticky ">
              <tr className="text-left">{renderTableHeader()}</tr>
            </thead>
            <tbody className="overflow-y-auto ">
              {(
                inspectionDetaildata?.data || inspectionDetaildata?.result
              )?.data?.map((row, index) => {
                const rowClass =
                  row?.is_valid_form === false
                    ? "bg-red-200 hover:bg-red-300"
                    : "";
                return (
                  <tr
                    key={index}
                    // className="text-sm text-[#626262] font-light hover:bg-gray-50"
                    className={`text-sm text-[#626262] font-light ${rowClass}`}
                  >
                    {renderTableRow(row)}
                    {/* <ErrorBoundary>{renderTableRow(row)}</ErrorBoundary> */}
                    <td className="px-4 py-3 whitespace-nowrap text-sm font-medium relative">
                      <HiDotsVertical
                        className="cursor-pointer"
                        onClick={(e) => handleMenuClick(e, row)}
                      />
                    </td>
                  </tr>
                );
              })}

              {(inspectionDetaildata?.data || inspectionDetaildata?.result)
                ?.data?.length === 0 && (
                <tr>
                  <td
                    colSpan="12"
                    className="px-6 py-8 text-center text-gray-500"
                  >
                    <div className="flex flex-col items-center justify-center">
                      <img
                        src="https://img.freepik.com/premium-vector/no-data-concept-illustration_86047-488.jpg?semt=ais_hybrid"
                        alt="No Data"
                        className="mb-4 w-[200px] h-[200px]"
                      />
                      <p className="text-lg text-gray-500">No results found</p>
                      <p className="text-sm text-gray-400">
                        Please check back later or create Inspection.
                      </p>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          <Menu
            anchorEl={menuState.anchorEl}
            open={Boolean(menuState.anchorEl)}
            onClose={handleClose}
          >
            {renderMenuItems()}
          </Menu>
        </div>
      )}

      {isFilterSidebarOpen && (
        <FilterSidebar
          isOpen={isFilterSidebarOpen}
          onClose={() => setIsFilterSidebarOpen(false)}
          onApplyFilters={handleApplyFilters}
          selectedIndex={selectedIndex}
          setOriginalFilters={setFilters}
          orginalFilters={filters}
          inspectionDetaildata={inspectionDetaildata}
        />
      )}

      <Modal
        open={deleteConfirmation?.open}
        onClose={handleDeleteCancel}
        className="flex items-center justify-center"
      >
        <Box className="bg-white text-center p-4 rounded-2xl shadow-md w-[90%] max-w-md mx-auto">
          <h2 className="text-xl font-bold mb-4">Confirm Deletion</h2>
          <p className="mb-6">Are you sure you want to remove this record?</p>
          <div className="flex justify-center space-x-4">
            <button
              onClick={handleDeleteConfirm}
              className="bg-red-500 text-white px-4 py-2 rounded-lg"
            >
              Yes, Remove
            </button>
            <button
              onClick={handleDeleteCancel}
              className="bg-gray-300 text-gray-700 px-4 py-2 rounded-lg"
            >
              Cancel
            </button>
          </div>
        </Box>
      </Modal>

      {downloadModalOpen && (
        <Modal
          open={downloadModalOpen}
          onClose={() => setDownloadModalOpen(false)}
          className="flex items-center justify-center"
        >
          <Box className="bg-white rounded-lg shadow-lg max-w-md w-full mx-4">
            <DownloadImages
              inspectionData={menuState.selectedRow}
              onDownload={() => handleDownload(menuState.selectedRow)}
              isDownloading={isDownloading}
              onClose={() => setDownloadModalOpen(false)}
            />
          </Box>
        </Modal>
      )}
      <div className="flex items-center justify-end mb-4 space-x-3">
        <div className="flex items-center mt-6 ">
          <label htmlFor="rows-per-page" className="mr-2">
            Rows per page:
          </label>
          <select
            id="rows-per-page"
            value={rowsPerPage}
            onChange={handleRowsPerPageChange}
            className="border border-solid border-2 h-[34px] rounded p-1 text-gray-500"
          >
            {rowsPerPageOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>

        {totalPages > 1 && rowsPerPage !== "All" && (
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
          />
        )}
      </div>
    </div>
  );
};

export default InspectionDetails;
